import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-34ef528e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "head-wrap"
};
const _hoisted_2 = {
  class: "info-wrap"
};
const _hoisted_3 = {
  class: "name-wrap"
};
const _hoisted_4 = {
  class: "name"
};
const _hoisted_5 = {
  class: "count"
};
const _hoisted_6 = {
  class: "desc"
};
const _hoisted_7 = {
  class: "date"
};
const _hoisted_8 = {
  class: "center-wrap"
};
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = {
  class: "desc"
};
const _hoisted_11 = {
  class: "bottom-wrap"
};
import CPage from '@/views/CPage.vue';
import AskList from '@/components/ask/ask-list.vue';
import composition from '@/composition';
import { computed } from '@vue/runtime-core';
export default {
  setup(__props) {
    const {
      ref,
      request,
      getQueryString,
      CImage,
      formatTime,
      store,
      openApp,
      wxShare
    } = composition();
    const id = getQueryString().id;
    const tagId = ref(id);
    const tag = ref({}); // 获取话题详情

    request.getTimelineTag(id).then(res => {
      window.zmyCollectionOpenActivityH5(id);
      tag.value = res.data;
      store.commit('setPageInfo', {
        pageType: 3,
        id: tag.value.id
      });
      wxShare(res.data.name, '问吧-身边人回答身边事', asker.face);
    }); // 问吧吧主信息

    const asker = computed(() => {
      let poster = {
        face: '',
        name: '',
        appellation: ''
      };

      if (tag.value.poster.professor) {
        // 有专家
        poster.face = tag.value.poster.professor.face;
        poster.name = tag.value.poster.professor.name;
        poster.appellation = tag.value.poster.professor.appellation;
      } else {
        // 没专家
        poster.face = tag.value.poster.photo;
        poster.name = tag.value.poster.nickname;
      }

      return poster;
    });
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");

      return _openBlock(), _createBlock(CPage, {
        model: tag.value
      }, {
        main: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(CImage), {
          class: "head-img",
          poster: tag.value.poster
        }, null, 8, ["poster"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, [_createTextVNode(_toDisplayString(_unref(asker).name) + " ", 1), _createElementVNode("span", _hoisted_5, _toDisplayString(tag.value.poster.handleCount) + "回答", 1)]), _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(asker).appellation), 1), _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(formatTime)(tag.value.updateTime, 'yyyy-MM-dd')), 1)])]), _createVNode(_component_van_image, {
          class: "banner-img",
          fit: "cover",
          src: tag.value.background
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, _toDisplayString(tag.value.name), 1), _createElementVNode("p", _hoisted_10, _toDisplayString(tag.value.description), 1)]), _createVNode(AskList, {
          tagId: tagId.value
        }, null, 8, ["tagId"]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
          class: "submit-btn",
          onClick: _cache[0] || (_cache[0] = $event => _unref(openApp)())
        }, "提问")])]),
        _: 1
      }, 8, ["model"]);
    };
  }

};